module.exports = __webpack_public_path__ + "static/eliya-cover-58bf82f3a3923c8945c79dd29f5078a7.jpg";